<template>
  <div class="fill-height">
    <div v-if="loading" class="fill-height d-flex align-items-center justify-content-center saving">
      <LoadingIndicator large />
    </div>
    <div v-else class="d-flex fill-height">
      <SelfServiceTaskBar
        style="flex: 1"
        :sections="sections"
        :selectedTaskId="selectedTaskId"
        @taskSelected="selectTask($event)"
        @goToDashboard="$router.push('/self-service')"
      />
      <transition name="fade" mode="in-out">
        <SelfServiceTaskView
          v-if="selectedTask"
          :task="selectedTask"
          :taskIndex="allTasks.indexOf(selectedTask)"
          style="flex: 5"
          :loading-prop="loadingTaskView || loadingGuidance"
          @complete="completeTask(selectedTask)"
          @nextTask="nextTask"
          :canComplete="selectedTask && selectedTaskId === firstIncompleteTask"
          :project-task-count="allTasks.length"
          :project="project"
          :project-completed="projectComplete"
          :task-template="taskTemplate"
        />
      </transition>
      <div v-if="!selectedTask" style="flex: 5">
      </div>
    </div>
  </div>
</template>

<script>
import SelfServiceTaskBar from "@/components/SelfService/TaskBar";
import SelfServiceTaskView from "@/components/SelfService/TaskView";
import moment from "moment";
import LoadingIndicator from "@/components/LoadingIndicator";
import Vue from "vue";

export default {
  name: "SelfServiceFlow",
  components: {LoadingIndicator, SelfServiceTaskView, SelfServiceTaskBar},
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      selectedTaskId: null,
      loading: false,
      project: null,
      projectLoaded: false,
      loadingTaskView: false,
      loadingGuidance: false,
      guidance: null
    }
  },
  mounted() {
    // TODO: Investigate why mounted hook is called again when navigating away from this view
    this.loadProject()
  },
  methods: {
    setProject(){
      this.project = JSON.parse(JSON.stringify(this.storeProject))
    },
    async loadProject(){
      try{
        this.loading = true;
        // const project =
          await this.$store.dispatch('getProjectDetail', this.storeProject.id);
        // const {data} =
          await this.$store.dispatch('getProjectActions', {
        id: this.storeProject.id,
        request_time: moment(),
      });
        this.loadGuidance();
      // const sections = (data && data.projects && data.projects.items);

        this.projectLoaded = true
        this.setProject()
        this.$nextTick(() => {
          this.nextTask()
        });
      } catch (e) {
        console.error('Could not load project')
      } finally {
        this.loading = false;
      }
    },
    async completeTask(task) {
      try{
        this.loadingTaskView = true;
        Vue.set(task, 'completed', true);
        await this.$store.dispatch('updateAction', {
          action: task,
          project_id: this.project.id,
          refresh_after: true,
        });

        if(this.projectComplete)
          this.completeProject();
        else
          this.nextTask()
      } catch (e) {
        console.error(e)
      } finally {
        this.loadingTaskView = false;
      }
    },
    async loadGuidance() {
      try {
        this.loadingGuidance = true;
        const guidance = await this.$store.dispatch('getActionTemplatesGuidance', this.allTasks.map(el => el.actionTemplateId));
        if (Array.isArray(guidance)) {
          this.guidance = guidance.reduce((obj, curr) => {
            if (!curr.actionTemplateId || !curr.value) return obj;
            obj[curr.actionTemplateId] = curr.value;
            return obj;
          }, {})
        }
      } catch (e) {
        console.error('Could not load guidance');
      } finally {
        this.loadingGuidance = false;
      }
    },
    nextTask(){
      this.selectedTaskId = null;
      this.$nextTick(() => {
        this.selectedTaskId = this.nextTaskUp;
      })
    },
    selectTask(id){
      this.selectedTaskId = null;
      this.$nextTick(() => {
        this.selectedTaskId = id;
      })
    },
    async completeProject() {
      this.project.status = 'Completed';
      this.$store.dispatch(
        'saveProject',
        this.project
      );
      this.$router.push('self-service');
    }
  },
  computed: {
    projects() {
      return this.$store.getters.projects;
    },
    storeProject() {
      if (!this.projects || !this.projectId) {
        return null;
      }

      // Forces the storeProject to refresh after it's been loaded and update in the store
      return this.projectLoaded ? this.projects[this.projectId] : this.projects[this.projectId]
      // return {...this.projects[this.projectId], suppliers: [
      //     {
      //       name: null,
      //       contactName: null,
      //       contactEmail: null,
      //       ratings: {
      //         price: 0,
      //         service: 0,
      //         quality: 0
      //       },
      //       cost: null,
      //       quotes: []
      //     },
      //     {
      //       name: null,
      //       contactName: null,
      //       contactEmail: null,
      //       ratings: {
      //         price: 0,
      //         service: 0,
      //         quality: 0
      //       },
      //       cost: null,
      //       quotes: []
      //     }
      //   ]};
    },
    sections(){
      return this.$store.getters.actions.map(actionGroup => {
        return {
          ...actionGroup,
          actions: !Array.isArray(actionGroup.actions) ? [] : actionGroup.actions.map((action) => {
            // const actionTemplate = this.allTemplateTasks.find(templateTask => templateTask.title === action.title)
            return action;
          })
        }
      })
    },
    allTasks(){
      return this.sections.reduce((tasks, el) => Array.isArray(el.actions) ? tasks.concat(el.actions) :  tasks, [])
    },
    selectedTask(){
      return this.allTasks.find(task => task.id === this.selectedTaskId)
    },
    firstIncompleteTask(){
      const firstIncomplete = this.allTasks.find(el => !el.completed)
      return firstIncomplete ? firstIncomplete.id : null;
    },
    nextTaskUp(){
      if(!this.selectedTask) return this.firstIncompleteTask;
      let currentIndex = this.allTasks.findIndex(task => task.id === this.selectedTask.id)
      return  currentIndex - 1 < this.allTasks.length ? (this.allTasks[currentIndex+1].id || null) : null;
    },
    projectComplete(){
      // return this.firstIncompleteTask === null
      return this.projectProgress === 100;
    },
    projectProgress(){
      const completedTasks = this.allTasks.filter(task => task.completed)
      return completedTasks.length / this.allTasks.length * 100;
    },
    taskTemplate(){
      return (this.selectedTask && this.selectedTask.actionTemplateId && this.guidance) ? this.guidance[this.selectedTask.actionTemplateId] : {};
    }
  }
}
</script>

<style lang="scss" scoped>
  .self-service-flow{
    display: flex;
    height: 100%;
  }
</style>
